export default __webpack_public_path__ + "4a0eb470d7cbdf1d9034255a95c3e322.png";